<template>
    <thead>
        <tr class="table__row--header table--hover--clickable__row--non_clickable">
            <th v-for="column in localizedColumns">{{column}}</th>
        </tr>
    </thead>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';

    @Component
    export default class GeoTableHead extends Vue {
        @Prop({type: String, default: 'country_id'})
        mode;
        @Prop({type: Array, default: () => (['lead'])})
        columns;

        get allColumns() {
            return [this.mode, ...this.columns];
        }

        get localizedColumns() {
            return this.allColumns.map(column => this.$t('widgets.geotable.columns.' + column));
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/geotable/GeoTableHead.vue